export default {
  setRTL: issue => {
    // console.log('Entrou setRTL')
    // global.isRTL = issue.title.categories.findIndex(x => x.id === 2) >-1;
    global.isRTL = issue.isRtl;
  },
  getRTL: () => {
    // console.log('Global Issue: -------> ', global.isRTL);
    return global.isRTL;
  }
};
